"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stein = void 0;
var Stein;
(function (Stein) {
    Stein["twsi"] = "twsi";
    Stein["wsi"] = "wsi";
    Stein["twif"] = "twif";
    Stein["princess"] = "princess";
    Stein["siSchwarz"] = "siSchwarz";
    Stein["siBlau"] = "siBlau";
    Stein["siGruen"] = "siGruen";
    Stein["siBraun"] = "siBraun";
    Stein["siGelb"] = "siGelb";
    Stein["rubin"] = "rubin";
    Stein["saphir"] = "saphir";
    Stein["smaragd"] = "smaragd";
    Stein["zirkonia"] = "zirkonia";
})(Stein = exports.Stein || (exports.Stein = {}));
//# sourceMappingURL=Stein.js.map